<template>
  <svg
    class="text-secondary"
    width="20px"
    height="20px"
    viewBox="0 0 64 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="currentColor"
  >
    <title>users</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g fill="currentColor" fill-rule="nonzero">
        <!-- Usuario central -->
        <circle cx="32" cy="20" r="8" class="color-background" />
        <path
          d="M16,50 C16,41.1634 23.1634,34 32,34 C40.8366,34 48,41.1634 48,50 L16,50 Z"
          class="color-background"
        />

        <!-- Usuario izquierdo -->
        <circle cx="14" cy="24" r="5" class="color-background" />
        <path
          d="M2,50 C2,43 7,38 14,38 C16.5,38 19,39 20.5,41 C16,43 13,46 12,50 Z"
          class="color-background"
        />

        <!-- Usuario derecho -->
        <circle cx="50" cy="24" r="5" class="color-background" />
        <path
          d="M44,38 C51,38 56,43 56,50 L52,50 C51,46 48,43 43.5,41 C45,39 47.5,38 50,38 Z"
          class="color-background"
        />
      </g>
    </g>
  </svg>
</template>
<script></script>
